export default __webpack_public_path__ + "static/media/vasesVessels.b07508c0.jpg";